import { render, staticRenderFns } from "./PostbackCreate.vue?vue&type=template&id=2bd9b67c&scoped=true"
import script from "./PostbackCreate.vue?vue&type=script&lang=js"
export * from "./PostbackCreate.vue?vue&type=script&lang=js"
import style0 from "./PostbackCreate.vue?vue&type=style&index=0&id=2bd9b67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9b67c",
  null
  
)

export default component.exports